import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, Theme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Home from './pages/home/Home';
import NotFound from './pages/not_found/NotFound';
import Snapshots from './pages/snapshots/Snapshots';
import Dex from './pages/dex/Dex';
import { LabProvider } from './context/lab';
import PageLayout from './components/PageLayout';
import AccountDetails from './pages/dex/components/AccountDetails';
import Snapshot from "./pages/snapshots/Snapshot";
import TransactionPage from "./pages/transaction";
import BlockPage from "./pages/block";
import AddressNotFoundPage from "./pages/addressNotFound";

const darkTheme: Theme = createTheme({
  palette: {
    mode: true ? 'dark' : 'light',
  },
  typography: {
    "fontFamily": `'Prompt', sans-serif`,
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500,
  }
});


function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <Paper  square={true} style={{"minHeight":"100vh"}}>
        <BrowserRouter>
          <LabProvider>
              <Routes>
                <Route path="/" element={<PageLayout />}>
                  <Route index element={<Home />} />
                  <Route path="tx/:txHash" element={<TransactionPage />} />
                  <Route path="block/:blockid" element={<BlockPage />} />
                  <Route path="address-error/:address" element={<AddressNotFoundPage />} />
                  
                  <Route path="snapshots" element={<Snapshots />} >
                    <Route path=":address" element={<Snapshot />} />
                  </Route>
                  <Route path="dex" element={<Dex />}  >
                    <Route path=":account" element={<AccountDetails />} />
                  </Route>
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
          </LabProvider>
        </BrowserRouter>
      </Paper>
    </ThemeProvider>
  );
}

export default App;
